module.exports = __webpack_public_path__ + "static/TimelessStrollPoster-becb1e843b8c6559cefa5024c5484b9a.jpg";